import React from 'react'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'

type ModalErrorCardProps = {
    show: boolean
    onHide: () => void
    passServerSideErrorMessage: string
    passHttpFailure: string
}

const ModalErrorCard: React.FC<ModalErrorCardProps> = ({
    show,
    onHide,
    passServerSideErrorMessage,
    passHttpFailure
}: ModalErrorCardProps) => {
    return (
        <Modal
            backdrop="static"
            className="modal-error-card--mongodb modal-sm"
            animation={false}
            onHide={onHide}
            show={show}
        >
            <Modal.Header className="modal-error-card-header">
                <Modal.Title className="modal-error-card-title">{i18n('Error details')}</Modal.Title>
                <a className="btn-alert-close" onClick={onHide}>
                    <i className="far fa-times" />
                </a>
            </Modal.Header>
            <Modal.Body className="modal-error-card-body">
                {passHttpFailure && (
                    <p>
                        <span className="modal-http-status">{i18n('HTTP status') + ': '}</span>
                        <span>{passHttpFailure + '.'}</span>
                    </p>
                )}
                {passServerSideErrorMessage && (
                    <p>
                        <span className="modal-server-failure">{i18n('Server side failure') + ': '}</span>
                        <span>{passServerSideErrorMessage}</span>
                    </p>
                )}
            </Modal.Body>
            <Modal.Footer className="modal-error-card-footer">
                <input type="button" className="btn btn-primary ok-btn" value={i18n('Ok')} onClick={onHide} />
            </Modal.Footer>
        </Modal>
    )
}

export default ModalErrorCard
